import React, { useState, useEffect } from "react";
import axios from "axios";

const SettingPage = ({ endpoint, title }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://mystore.betamoneta.com/api/settings/${endpoint}`)
      .then((response) => {
        const result = response.data?.data || response.data;
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        console.error(`Error fetching ${endpoint}:`, err);
        setError(
          "حدث خطأ أثناء تحميل البيانات، يرجى المحاولة مرة أخرى لاحقاً.",
        );
        setLoading(false);
      });
  }, [endpoint]);

  return (
    <div className="container my-5 py-5" style={{ minHeight: "60vh" }}>
      <div className="row justify-content-center">
        <div className="col-lg-10 col-12">
          <h2 className="mb-4 text-dark fw-bold pb-2 border-bottom">{title}</h2>

          {loading && (
            <div className="d-flex justify-content-center my-5">
              <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {error && (
            <div className="alert alert-danger text-center my-4" role="alert">
              {error}
            </div>
          )}

          {!loading && !error && data && (
            <div className="content-area text-secondary lh-lg fs-5">
              {typeof data === "object" ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.content || data.value || JSON.stringify(data),
                  }}
                />
              ) : (
                <div dangerouslySetInnerHTML={{ __html: data }} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingPage;
